import React from 'react'
import Grid from '@mui/material/Grid'
import Autocomplete from '@mui/material/Autocomplete'
import Box from '@mui/material/Box'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import EmployeeSelector from '../../../events/EmployeeSelector'

const StaffInvolved = ({ formValues, handleChange }) => {
  const selectedStaff = formValues?.incident?.staffInvolved || []
  const getStaffId = (staff) => String(staff?._id || staff || '')
  const lockedStaffIds = new Set(
    (formValues?.incident?.lockedStaffInvolved || []).map(getStaffId),
  )
  const lockedStaff = selectedStaff.filter((staff) =>
    lockedStaffIds.has(getStaffId(staff)),
  )

  return (
    <Grid item xs={12}>
      <EmployeeSelector
        fullWidth
        multiple
        onChange={(e, value) => {
          const selectedIds = new Set((value || []).map(getStaffId))
          const restoredLockedStaff = lockedStaff.filter(
            (staff) => !selectedIds.has(getStaffId(staff)),
          )

          handleChange({
            moduleName: 'incident',
            field: 'staffInvolved',
            value: [...(value || []), ...restoredLockedStaff],
          })
        }}
        value={selectedStaff}
        valueType="employee"
        label="Staff Involved in Patient Care"
        includeSubcontractor
      />
    </Grid>
  )
}

export default StaffInvolved
